import { ApplyStage } from './ApplyStage'
import { Box } from '@mui/material'
import { ErrorBoundary } from '@sentry/react'
import { PipelineStatus } from './PipelineStatus'
import { PrepareStage } from './PrepareStage'
import { ProcessStage } from './ProcessStage'
import React from 'react'
import { useNodeOrTree } from './hooks/useNodeOrTree'
import { useParams } from 'infrastructure/routing'
import { useSearchParams } from 'shared/hooks'
import { useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { workingTreeAtom } from './atoms'

export function SVGtoLaTEXConverter(ids: {
  treeId: string
  versionId: string
}) {
  const [searchParams] = useSearchParams()
  const { NodeId } = useParams()
  const nodeId = NodeId ?? searchParams.get('nodeId')
  const { tree, loading } = useNodeOrTree({
    treeId: ids.treeId,
    versionId: ids.versionId,
    nodeId: nodeId ?? undefined,
  })

  useSetAtom(workingTreeAtom)(tree)

  if (loading) return <Box>Loading...</Box>
  if (!loading && !tree) return <Box>No tree found</Box>

  return (
    <Box>
      <PipelineStatus treeId={ids.treeId} versionId={ids.versionId} />
      <PrepareStage treeId={ids.treeId} versionId={ids.versionId} />
      <ProcessStage treeId={ids.treeId} versionId={ids.versionId} />
      <ApplyStage treeId={ids.treeId} versionId={ids.versionId} />
    </Box>
  )
}

export function SVGtoLatexWrapper({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  // use error boundary to catch errors
  return (
    <ErrorBoundary>
      <SVGtoLaTEXConverter treeId={treeId} versionId={versionId} />
    </ErrorBoundary>
  )
}
